
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(33112|5996)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
